// extracted by mini-css-extract-plugin
export default {"normalIcon":"Group_normalIcon__GS6Hr","errorText":"Group_errorText__oCaO+","warningText":"Group_warningText__j76OS"};